export default "__VITE_ASSET__i7riQ5JF__"